export enum NavigationSearchParams {
  projectAccessTab = "projectAccessNavUuid",
  settingsProjectAccessTab = "settingsProjectAccessTabNavUuid",
}
